import { HourglassEmptyOutlined } from '@mui/icons-material';
import { Stack } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Stack)`
  border: 1px solid #e0e0e0;
  padding-block: 8px;
  width: 100%;
  justify-content: center;
  gap: 12px;
  border-radius: 4px;
  flex-direction: row;
`;

export const ExecutiveProducerNotice = () => (
  <Container>
    <HourglassEmptyOutlined />
    Aguardando Produtor executivo
  </Container>
);
